import styles from './MiniRoute.module.css';

const COLORS = ['var(--color-l1)', 'var(--color-l2)', 'var(--color-l3)'];

export function MiniRoute({ letters }: { letters: [string, string, string] }) {
  return (
    <div className={styles.row}>
      {letters.map((ch, i) => (
        <div
          key={i}
          className={styles.tile}
          style={{ color: COLORS[i] } as React.CSSProperties}
        >
          {ch.toUpperCase()}
        </div>
      ))}
    </div>
  );
}
